import { debounce } from 'lodash';
import CONFIG from './config.json';

export default function bouncedSearch(searchAction) {
    return debounce((search) => {
        $('.infinite-scroll-inner').scrollTop(0);
        searchAction(search);
    }, CONFIG.SEARCH_DELAY);
}
